export default {
    customer:{
        logintitle:'Account Login',
        email:'Email',
        password:'Password',
        loginbtn:'Log in ',
        loginSuccess:'Login successful',
        otherloginMode:'Other method',
        RechargeCore:'Pay center',
        RechargeCores:'Pay center - U.LU Games',
        AccountsDele:'Accountremoved',
        AccountsSeal:'Account banned',
        PasswordError:'Worng Password',
        AccountsNotence:'Account not exist',
        EmailFormatError:'Wrong format',
        PlacePassword:'Input password',
        PlaceEmail:'Input email',
        parameterIncomplete:'Incomplete parameters',
        Rechargeption:'(Recharge Instruction)',
        Rechargeption2:'Recharge Instruction',
        obtainGameFail:'Pls refresh the page, cannot get the game info',
        placePayMode:'Pls refresh the page, cannot get the game info',
    },
    RechargePage:{
        logout:'Logout',
        Rechargeccount:'Recharge Account',
        game:'Game',
        TheServer:"Server",
        RoleNickname:"Nickname",
        placeChTheSer:"Select server",
        PlaceChNickN:"Select nickname",
        PayMode:"Payment Method",
        ChoosCommodity:"Select Items",
        OrderHathair:"Order not complete",
        HelpConCusSer:"If need help, pls contact cs@ulugame.com",
        GlobalException:"Global Exception",
        good:"Ok",
        OrderCompleted:"Order is complete",
        SuccessBuy:"You have finished the payment",

        Databaseerror:"Database error",
        operror:"Database operation exception",
        Invaildlogin:'Invalid login, pls try again',
        Emailwasbinded:'This email has been used already',
        Codeerror:'Wrong verification code',
        bindedalready:'This account has been used already',
        ULUaccount:"This account has been bind to ULU account",
        Codeinvalid:'Verfication code expired',
        haveRegist:"The account has been registered, pls try later",
        Requestfrequently:"Too frequent request, pls try later",
        notRegister:"Unregistered",
        oneBind:"Need to bind a email before unbind all 3rd party accounts",
        idError:"Wrong account, pls input the correct unbind account",
        Noorvicnleund:'No service and role',
        gamesempty:'Game is empty',
        determin:'determine',
        Ordercancelled:'Order has been canceled',
        Rechargeonfirmation:'Recharge Confirmation',
        Confirmwingarormation:'Please confirm the following recharge information.',
        BuyGoods:'item',
        cancel:'cancel',

        RoleNickID:'캐릭터ID',
        PlaceNickID:'캐릭터ID를 입력해주세요.',
        check:'검증',
        PlaceCheckID:'캐릭터ID를 검증해주세요.',
        CheckSuccess:'검증 완료, 캐릭터명은:',
        VerificationFailed:'검증에 실패하였습니다. 존재하지 않는 캐릭터입니다.',
        SystemError:'시스템 에러',
        InterfaceException:'연결에 실패하였습니다.',
        FrequentVisits:'방문히 너무 빈번합니다.',
        NetworkAnomaly:'인터넷 불안정',


        PleLoginFirst:'Pls log in game account',
        RecharRoleInformation:'Pay role info',
        TotalAmount:'Pay amount',
        ImmediatePayment:'Pay now',
        PleaseVerifyServer:'Pls verify server',
        PayRole:'Pay role',
        PlsselectRole:'Pls select role'
    },
}
